import angular from 'angular';

angular
    .module('resumption')

    .controller('LadSpecificModalCtrl', [
        '$scope',
        '$uibModalInstance',
        'envelopes',
        function($scope, $uibModalInstance, envelopes) {
            $scope.envelopes = envelopes;

            $scope.ok = function() {
                if ($scope.form.$valid) {
                    $uibModalInstance.close();
                }
            };

            $scope.cancel = function() {
                $uibModalInstance.dismiss('cancel');
            };
        }
    ]);
